export function WhatsappTemplateExitConstructor(services) {

  const joint = services.joint;

  return joint.shapes.html.AbstractNonDragableElementWithOutPort.extend({
    defaults: joint.util.deepSupplement({
      'type': 'html.WhatsappTemplateExit'
    }, joint.shapes.html.AbstractNonDragableElementWithOutPort.prototype.defaults)
  });
}
